// extracted by mini-css-extract-plugin
export default {"quitGame":"QuitGame_quitGame__jPQSj","title":"QuitGame_title__o3rad","buttonWrap":"QuitGame_buttonWrap__7YzWf","quitButton":"QuitGame_quitButton__RtXbH"};